import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[preventDecimal]'
})
export class PreventDecimal {
  constructor() {
  }

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === '.') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: any) {
    const pastedText = event.clipboardData.getData('text/plain');

    if (pastedText.includes('.')) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/prevent-decimal.ts